import { ButtonType, DialogFooterButtonsWidget, DialogPositioningBehavior, DialogType, DialogWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../../codegen/Localize';

export interface WelcomeChannelNavigationDialogProps {
  handleNavigation: () => void;
  handleSave: () => void;
  handleClose: () => void;
}

/**
 * The Tableau styled dialog that appears on the Customization Settings
 * when a user tries to navigate away while they have unsaved changes.
 */
export class WelcomeChannelNavigationDialog extends React.PureComponent<WelcomeChannelNavigationDialogProps> {
  render() {
    const footerContent =
      <DialogFooterButtonsWidget
        testId={'navigationFooter'}
        buttons={[
          {
            buttonType: ButtonType.Outline,
            children: Messages.settings_welcomeChannel_dialog_close(),
            testId: 'customization-settings-navigation-dialog-footer-cancel',
            handleClick: () => {
              this.props.handleNavigation();
              this.props.handleClose();
            }
          },
          {
            buttonType: ButtonType.Primary,
            children: Messages.save(),
            testId: 'customization-settings-navigation-dialog-footer-confirm',
            handleClick: () => {
              this.props.handleSave();
              this.props.handleNavigation();
              this.props.handleClose();
            },
          }
        ]}
      />;

    return (
      <DialogWidget
        title={Messages.settings_welcomeChannel_dialog_title()}
        onCloseRequest={this.props.handleClose}
        isModal={true}
        positioningBehavior={DialogPositioningBehavior.Centered}
        showCloseButton={true}
        showFooter={true}
        dialogWidth={375}
        testId={'navigationDialog'}
        type={DialogType.NormalWithTitleBar}
        footerContent={footerContent}
      >
        {Messages.settings_welcomeChannel_dialog_description()}
      </DialogWidget>
    );
  }
}
